import {Component, NgZone} from "@angular/core";

import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ComponentBase} from "../base/ComponentBase";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {PipelineService} from "../services/pipeline/pipeline.service";
import {ISelection, ITranslation, IGlossaryEntry} from  "../api/data-model";
import {RaVersion} from "../services/configuration/ra.version";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: "verifier",
    templateUrl: "./verifier.editor.component.html",
    styleUrls: ["./pipeline.component.scss"]
})
export class VerifierEditorComponent extends ComponentBase {

    public activateModal: boolean = false;
    public status:string = "";
    public checkInProgress = false;
    public saveClicked = false;
    public errorString = "";

    constructor (
        private http:HttpClient,
        private eventBus: EventBus,
        private modalConfig: ModalConfig,
        private logService: BugsnagLoggingService,
        private _ngZone: NgZone,
        private pipelineService:PipelineService
    ) {
        super("VerifierEditorComponent");
    }

    get selection(): ISelection {
        return this.pipelineService.currentSourceSelection;
    }

    public checkGlossary():void {
        // alert("check glossary here");
        this.resetState();
        // TODO: don't think we need to create the inflated content here and below.
        this.pipelineService.inflateContent().subscribe(finalResult => {
                this.logService.log("Inflated Content for glossary check");
                this.errorString = this.pipelineService.analyzeGlossary();
                this.checkInProgress = false;
            }
        );
    }



    public checkReadToMeAudio(): void {
        this.resetState()
        this.pipelineService.inflateContent().subscribe(finalResult => {
                this.logService.log("Inflated Content for narration audio check");
                this.pipelineService.analyzeReadToMeAudio().subscribe((result) => {
                    this.checkInProgress = false;
                    this.errorString = result;
                });
            }
        );
    }
    public checkQuestionAudio(): void {
        this.resetState();
        this.pipelineService.inflateContent().subscribe(finalResult => {
                this.logService.log("Inflated Content for question audio check");
                this.pipelineService.analyzeReadToMeAudio().subscribe((result) => {
                    this.checkInProgress = false;
                    this.errorString = result;
                });
            }
        );
    }

    public checkWordAudio(): void {
        this.resetState()
        this.pipelineService.inflateContent().subscribe(finalResult => {
                this.logService.log("Inflated Content for word audio check");
                this.pipelineService.analyzeWordAudio().subscribe((result) => {
                    this.checkInProgress = false;
                    this.errorString = result;
                });

            }
        );
    }

    public checkGlossaryAudio(): void {
        this.resetState()
        this.pipelineService.inflateContent().subscribe(finalResult => {
                this.logService.log("Inflated Content for glossary check");
                this.pipelineService.analyzeGlossaryAudio().subscribe((result) => {
                    this.checkInProgress = false;
                    this.errorString = result;
            });
            }
        );
    }
    private resetState() {
        this.errorString = "";
        this.checkInProgress = true;
        this.saveClicked = false;
    }

    public transitionAudioState() {
        this.saveClicked = true;
        this.pipelineService.transitionAudioState();
    }

    public makeActive(): void {

    }

    public makeInactive():void {

    }
}
